import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'signOutLanding.title',
    defaultMessage: 'You’ve successfully logged out',
  },
  subMessage: {
    id: 'signOutLanding.subMessage',
    defaultMessage: 'Need to get back in? Log in to access your account',
  },
  MFAButton: {
    id: 'signOutLanding.MFAButton',
    defaultMessage: 'Log in',
  },
  MFAConfigError: {
    id: 'signOutLanding.MFAConfigError',
    defaultMessage: 'MS Entra login is not configured correctly. Please contact support.',
  },
});

export default messages;
